import { IconButton, type IconButtonProps, Icon } from '@chakra-ui/react';
import { MenuIcon, XIcon } from 'lucide-react';
import { iconSize } from '@duke-hq/ui/constants/scalable';

interface ToggleButtonProps extends IconButtonProps {
  isOpen: boolean;
}

export function ToggleButton(props: ToggleButtonProps) {
  const { isOpen, ...iconButtonProps } = props;
  return (
    <IconButton
      variant="unstyled"
      size="md"
      color="fg.default"
      icon={
        isOpen ? (
          <Icon as={XIcon} boxSize={iconSize.xl} />
        ) : (
          <Icon as={MenuIcon} boxSize={iconSize.xl} />
        )
      }
      {...iconButtonProps}
    />
  );
}
